import { Designation } from './designation.model';

export class ActivateDesignation {
  static readonly type = '[Designations] Activate Designation';
}

export class AddDesignation {
  static readonly type = '[Designations] Add Designation';
  constructor(public payload: Designation) {}
}

export class RemoveDesignation {
  static readonly type = '[Designations] Remove Designation';
  constructor(public payload: number) {}
}

export class ReplaceDesignation {
  static readonly type = '[Designations] Replace Designation';
  constructor(public payload: { toReplace: Designation; toUse: Designation }) {}
}

export class SetNoteValue {
  static readonly type = '[Designations] Set Note Value';
  constructor(public payload: { index: number; value: string }) {}
}

export class SetCommentsValue {
  static readonly type = '[Designations] Set Comments Value';
  constructor(public payload: string) {}
}

export class SetCustomDesignation {
  static readonly type = '[Designations] Set Custom Designation';
  constructor(public payload: string) {}
}

export class SetDesignations {
  static readonly type = '[Designations] Set Designations';
  constructor(public payload: Designation[]) {}
}

export class SetTotal {
  static readonly type = '[Designations] Set Total';
  constructor(public payload: number) {}
}
